import core from '@gvdasa/gv-core';
import {Environment} from 'shared/Env/Environment';

const Api = core.GVHttpClient(Environment);

export {Api};
